import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogOrderComponent } from './dialogOrder.component';
import { SharedModule } from '@/shared/shared.module';

@NgModule({
  declarations: [DialogOrderComponent],
  imports: [CommonModule, SharedModule],
})
export class DialogOrderModule {

}
